$(document).on('click', '[data-close]', function (e) {
    if (e.isTrigger === 3) return;
    e.preventDefault();

    const classToRemove = $(this).data('close-remove');

    $($(this).data('close')).removeClass(classToRemove).trigger('close');

});